import LegalLayout from '../components/LegalLayout'

const reabrirBanner = () => {
  try { localStorage.removeItem('cookie_consent_v1') } catch {}
  window.location.reload()
}

export default function Cookies() {
  return (
    <LegalLayout
      title="Política de cookies"
      description="Política de cookies de PresenzIA: qué cookies usamos, con qué finalidad, durante cuánto tiempo y cómo configurar tus preferencias en cualquier momento."
      lastUpdate="3 de mayo de 2026"
      canonicalPath="/cookies"
    >
      <p>
        Esta política explica qué cookies utiliza PresenzIA, con qué finalidad y cómo puedes
        gestionar tus preferencias en cumplimiento del artículo 22.2 de la LSSI-CE y de la guía
        de la Agencia Española de Protección de Datos (AEPD).
      </p>

      <h2>1. ¿Qué son las cookies?</h2>
      <p>
        Las cookies son pequeños archivos de texto que un sitio web almacena en tu dispositivo.
        Sirven para recordar información (sesión, preferencias) o para medir cómo se usa la web.
      </p>

      <h2>2. ¿Qué cookies usamos?</h2>
      <table>
        <thead>
          <tr>
            <th>Cookie / Almacenamiento</th>
            <th>Tipo</th>
            <th>Finalidad</th>
            <th>Duración</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>token</code> (localStorage)</td>
            <td>Necesaria propia</td>
            <td>Mantener la sesión de usuario autenticado.</td>
            <td>20 horas</td>
          </tr>
          <tr>
            <td><code>cookie_consent_v1</code> (localStorage)</td>
            <td>Necesaria propia</td>
            <td>Recordar tus preferencias de cookies.</td>
            <td>12 meses</td>
          </tr>
          <tr>
            <td><code>login_timestamp</code> (sessionStorage)</td>
            <td>Necesaria propia</td>
            <td>Control de inicio de sesión.</td>
            <td>Hasta cerrar pestaña</td>
          </tr>
          <tr>
            <td><code>_ga</code>, <code>_ga_*</code></td>
            <td>Analítica de terceros (Google)</td>
            <td>Distinguir usuarios y sesiones para analítica web (GA4) con IP anonimizada.</td>
            <td>Hasta 2 años</td>
          </tr>
        </tbody>
      </table>
      <p>
        <strong>Las cookies analíticas sólo se activan si das tu consentimiento</strong> en el
        banner. Por defecto están denegadas mediante Google Consent Mode v2.
      </p>
      <p>
        No utilizamos cookies de publicidad ni de redes sociales. No realizamos perfilado del
        usuario.
      </p>

      <h2>3. Base legal</h2>
      <ul>
        <li><strong>Cookies necesarias:</strong> interés legítimo y/o ejecución del servicio.</li>
        <li><strong>Cookies analíticas:</strong> consentimiento explícito del usuario (art. 22.2 LSSI-CE).</li>
      </ul>

      <h2>4. Gestionar tus preferencias</h2>
      <p>
        Puedes cambiar tu decisión en cualquier momento. Al pulsar el botón siguiente
        reabriremos el banner para que elijas de nuevo:
      </p>
      <p>
        <button
          type="button"
          onClick={reabrirBanner}
          className="inline-flex items-center px-5 py-2.5 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
        >
          Configurar cookies
        </button>
      </p>
      <p>
        También puedes bloquear o eliminar cookies desde la configuración de tu navegador. Ten
        en cuenta que algunas funcionalidades pueden dejar de operar correctamente si bloqueas
        las cookies necesarias.
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Chrome</a></li>
        <li><a href="https://support.mozilla.org/es/kb/Borrar%20cookies" target="_blank" rel="noopener noreferrer">Firefox</a></li>
        <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
        <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noopener noreferrer">Edge</a></li>
      </ul>

      <h2>5. Transferencias internacionales</h2>
      <p>
        Google Analytics es operado por Google Ireland Ltd. (UE). Google puede transferir datos
        a EE.UU. al amparo del marco "EU-US Data Privacy Framework". Aplicamos IP anonimizada
        para minimizar la transferencia de datos identificables.
      </p>

      <h2>6. Cambios en la política</h2>
      <p>
        Si modificamos esta política, publicaremos la versión actualizada en esta página y, si
        los cambios son sustanciales, te volveremos a pedir consentimiento.
      </p>

      <h2>7. Contacto</h2>
      <p>
        Para cualquier cuestión sobre esta política, escríbenos a <strong>privacidad@presenzia.app</strong>.
      </p>
    </LegalLayout>
  )
}
